
var href = window.location.origin;
export default {

  host: href,
//   host:'http://localhost:8081',
  // host: "http://btn.iweisu.com",
};